<template>
  <div class="better" id="qy">
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
import * as api from '@/api/book.js'
export default {
  name: 'app',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true,
      transitionName: ''
    }
  },
  watch: {
    $route (to, from) {
      if (to.name != 'onboarding' && !to.meta.share) {
        // this.getShare()
      }
    }
  },
  destroyed () {
    window.removeEventListener('popstate', this.goBack, false)
  },
  mounted () {
    if (sessionStorage.getItem('playLocalId')) {
      this.endPlay(sessionStorage.getItem('playLocalId'))
    }
    // 拦截后退
    if (window.history && window.history.pushState) {
      window.addEventListener('popstate', this.goBack, false)
    }
  },
  methods: {
    // 停止播放
    endPlay (id) {
      wx.stopVoice({localId: id})
      sessionStorage.removeItem('playLocalId')
    },
    getShare () {
      var shareData = sessionStorage.getItem('initData')
      if (shareData) {
        this.wxshare(JSON.parse(shareData).share)
      } else {
        var params = {
          sharetype: 'default'
        }
        api.getShare(params).then((res) => {
          let sv = res.share
          sessionStorage.setItem('initData', JSON.stringify(res))
          this.wxshare(sv)
        })
      }
    },
    wxshare (sv) {
      // 微信分享
      if (this.$wxShare.isWeixin()) {
        this.$wxShare.baseConfig({
            title: sv.title,
            desc: sv.desc,
            imgUrl: sv.imgUrl
        })
      }
    },
    goBack () {
      self.location.reload()
    },
    reload () {
      var _that = this
      this.isRouterAlive = false
      this.$nextTick(() => {
        _that.isRouterAlive = true
      })
    }
  }
}
</script>

<style lang="less">
@import './assets/css/reset.css';
#app, #qy {
  height: 100%;
  // font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue